import { StatusColor } from './types';

export class APIError extends Error {
  message: string;
  status: number;
  color: StatusColor;

  constructor(message: string, status: number) {
    super(message);
    this.message = message;
    this.status = status;
    this.color = 'danger';
    this.name = `APIError [${this.status} - ${this.message}]`;
  }
}

export const API_ERROR = {
  NETWORK_CONNECTIVITY: new APIError(
    'Network connectivity error: please check for ad blocker or network outage.',
    0,
  ),
  GATEWAY_TIMEOUT: new APIError(
    'Error retrieving data. Reason: API Timeout.',
    504,
  ),
  COMMUNICATION_FORMAT: new APIError(
    'Communication error contacting server. Please try again.',
    500,
  ),
  UNKNOWN: new APIError(
    'An unknown error has occurred. Arctic Wolf has been notified. Please refresh your browser and try again.',
    500,
  ),
};
